<template>
  <div class="content">
   
    <LTable class="table-hover table-striped" @add_user="showEditForm" @edit_trucker="showForm" @add_registration="showRegistrationForm"> </LTable>
    <add-truckers ref="add_truckers" > </add-truckers>
    <add-registration ref="add_registration" > </add-registration>
    <edit-truckers ref="edit_truckers"> </edit-truckers>
        
  </div>
</template>
<script>
  import LTable from 'src/components/Truckers/TruckersListing.vue'
  import AddTruckers from '../../components/Truckers/AddTruckers.vue'
  import EditTruckers from '../../components/Truckers/EditTrucker.vue'
  import AddRegistration from '../../components/Truckers/AddRegistration.vue'
  
  export default {
    components: {
      LTable,
      AddTruckers,
      EditTruckers,
      AddRegistration
    },
    data () {
      return {
        
      }
    },
    methods:{
        showEditForm() {
          this.$refs.add_truckers.show()
        },

        showForm(trucker){
          this.$refs.edit_truckers.show(trucker)
        },

        showRegistrationForm(trucker){
          this.$refs.add_registration.show(trucker)
        }

    }
  }
</script>


<style>
.table {
    margin-left: 14px;
}
</style>
